<template>
  <div class="row">
    <carousel :autoplay="true" :nav="false" :autoplayTimeout="10000" :items="1" class="container">
      <div class="item row">
        <div class="col-lg-6 col-sm-6 align-self-center" id="hero">
          <h1 class="color-red"> Hot deal 90% OFF</h1>
          <h2>
           Keep your entire family safe with our new deal. Up to 90% off the original price.
          </h2>
          <a @click="trackClick('90% OFF')" class="main_btn mt-40 text-centre" href="/shop">Shop Now</a>
          <br/>
        </div>
        <div class="col-lg-4 col-sm-6">
          <img src="../assets/img/banner/promo.png" class="responsive" />
        </div>
      </div>

      <div class="item row">
        <div class="col-md-6 col-sm-6 align-self-center" id="hero">
          <h1 class="color-red">Back to School?</h1>
          <h2>
           Our sanitizer wristbands are perfect for kids going back to school. Help your kids stay safe.
          </h2>
          <a @click="trackClick('Back to School')" class="main_btn mt-40 text-centre" href="/shop">Shop Now</a>
          <br/>
        </div>
        <div class="col-md-6 col-sm-6">
          <img src="../assets/img/banner/back-2-shcool.png" class="responsive" />
        </div>
      </div>

      <div class="item row featurette">
        <div class="col-md-6 col-sm-6 order-md-2 align-self-center" id="hero">
          <h1 class="display-3">
            Sanitizer
            <span class="text-muted">Wristbands.</span>
          </h1>
          <h2>
            Our wristbands stick with you all day long so you can stay free of germs and viruses.</h2>
          <a @click="trackClick('Video Preview')" class="main_btn mt-40" href="/shop">Buy Now</a>
        </div>
        <div class="col-md-6 col-sm-6 order-md-1">
          <VideoBanner/>
        </div>
      </div>

    </carousel>
  </div>
</template>
<script>
import carousel from 'vue-owl-carousel2'
import VideoBanner from '@/components/Video'
export default {
  components: { carousel, VideoBanner },
  methods: {
    trackClick (source) {
      window.analytics.track('Clicked from Carousel', {
        destination: 'Shop',
        source,
        type: 'button'
      })
    }
  }
}
</script>
<style scope>
#hero h1 {
  margin: 0 0 15px 0;
  font-size: 48px;
  font-weight: 700;
  line-height: 56px;
  font-family: "Poppins", sans-serif;
  color: #474747
}
#hero h2 {
  margin-bottom: 30px;
  font-size: 22px;
  color: #6F7C80;
  font-family: "Roboto", sans-serif;
}
#hero .btn-get-started {
  color: #213b52;
  border-radius: 50px;
  padding: 8px 35px 10px 35px;
  border: 2px solid #fdc134;
  transition: all ease-in-out 0.3s;
  display: inline-block;
  background: #fdc134;
}
.ca {
  min-height: 500px;
}
@media (max-width: 360px){
  .col-sm-6 {
    max-width: 50%;
  }
  #hero h1 {
    margin: 0 0 7px 0;
    font-size: 24px;
    font-weight: 350;
    line-height: 28px;
  }
  #hero h2 {
    margin-bottom: 15px;
    font-size: 11px;
    color: #6F7C80;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue